module.exports = __webpack_public_path__ + "media/fonts/suisse-intl/SuisseIntl-Light-WebS-3a238512be7543295d60341001b89322.woff2";